export const PAYMENT_AGENT_DOCUMENT_URL =
  "https://oysterhr-public-assets.s3.eu-west-1.amazonaws.com/documents/legal-pack/Payment+Agent+Appointment+Agreement_Contractor+Product_Final.pdf"

export enum PaymentHistoryItemType {
  Charge,
  CreditNote,
}
